module.exports = __webpack_public_path__ + "img/download_video.81fea0d9.gif";